<template>
  <div class="content">
    <div class="news">
      <h2>企业新闻</h2>
      <h3 class="mt-10">了解品农商用车最新新闻动态</h3>
      <el-row class="mt-40">
        <template v-if="newData.length === 0">
          <img
            src="@image/notMsg.png"
            alt=""
            style="border-radius: 4px;
    border: 1px solid #EBEEF5;margin-right:20px"
          />
        </template>
        <template v-else>
          <el-col :span="22">
            <el-card :body-style="{ padding: '0px' }">
              <div class="imgbox" @click="handleMsg(headerNew.id)">
                <img
                  :alt="headerNew.title"
                  :src="headerNew.cover"
                  class="image"
                />
                <div>
                  <p class="ell ml-20">
                    {{ headerNew.title }}
                  </p>
                </div>
              </div>
              <div style="padding: 14px;">
                <div class="bottom clearfix">
                  <div
                    v-for="item in newData"
                    :key="item.id"
                    @click="handleMsg(item.id)"
                    class="msg_new"
                  >
                    <p class="ell">
                      {{ item.title }}
                    </p>
                    <span>
                      {{ item.issue_time | dateFormat('YYYY-MM-DD') }}</span
                    >
                  </div>
                </div>
                <router-link
                  :to="{
                    name: ylStatus ? 'news_yl' : 'news',
                    query: { routerPath: 'qyxw' }
                  }"
                >
                  <div class="pad">查看更多</div>
                </router-link>
              </div>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>
    <div class="news">
      <h2>行业动态</h2>
      <h3 class="mt-10">了解商用车行业最新动态</h3>
      <el-row class="mt-40">
        <template v-if="newsData.length === 0">
          <img
            src="@image/notMsg.png"
            alt=""
            style="border-radius: 4px;
    border: 1px solid #EBEEF5;margin-right:20px"
          />
        </template>
        <template v-else>
          <el-col :span="22">
            <el-card :body-style="{ padding: '0px' }">
              <div class="imgbox" @click="handleMsg(headerNews.id)">
                <img
                  :alt="headerNews.title"
                  :src="headerNews.cover"
                  class="image"
                />
                <div>
                  <p class="ell ml-20">
                    {{ headerNews.title }}
                  </p>
                </div>
              </div>
              <div style="padding: 14px;">
                <div class="bottom clearfix">
                  <div
                    v-for="list in newsData"
                    :key="list.id"
                    @click="handleMsg(list.id)"
                    class="msg_new"
                  >
                    <p class="ell">{{ list.title }}</p>
                    <span>{{
                      list.issue_time | dateFormat('YYYY-MM-DD')
                    }}</span>
                  </div>
                </div>
                <router-link
                  :to="{
                    name: ylStatus ? 'news_yl' : 'news',
                    query: { routerPath: 'hydt' }
                  }"
                >
                  <div class="pad">查看更多</div>
                </router-link>
              </div>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>

    <div class="news">
      <h2>伙伴频道</h2>
      <h3 class="mt-10">了解品农合作伙伴</h3>
      <el-row class="mt-40">
        <template v-if="news.length === 0">
          <img
            src="@image/notMsg.png"
            alt=""
            style="border-radius: 4px;
    border: 1px solid #EBEEF5;"
          />
        </template>
        <template v-else>
          <el-col :span="22">
            <el-card :body-style="{ padding: '0px' }">
              <div class="imgbox" @click="handleMsg(newsMsg.id)">
                <img :alt="newsMsg.title" :src="newsMsg.cover" class="image" />
                <div>
                  <p class="ell ml-20">
                    {{ newsMsg.title }}
                  </p>
                </div>
              </div>
              <div style="padding: 14px;">
                <div class="bottom clearfix">
                  <div
                    v-for="listMsg in news"
                    :key="listMsg.id"
                    @click="handleMsg(listMsg.id)"
                    class="msg_new"
                  >
                    <p class="ell">{{ listMsg.title }}</p>
                    <span>{{
                      listMsg.issue_time | dateFormat('YYYY-MM-DD')
                    }}</span>
                  </div>
                </div>
                <router-link
                  :to="{
                    name: ylStatus ? 'news_yl' : 'news',
                    query: { routerPath: 'hzxw' }
                  }"
                >
                  <div class="pad">查看更多</div>
                </router-link>
              </div>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getNews } from '@/api/news'
export default {
  name: 'CompanyNews',
  data() {
    return {
      newData: [],
      newsData: [],
      news: [],
      headerNew: '',
      headerNews: '',
      newsMsg: '',
      ylStatus: this.$store.getters.urlStatus
    }
  },
  created() {
    this.init(1)
    this.init(2)
    this.init(3)
  },
  methods: {
    init(num) {
      const data = { cate_id: num, page_size: 5 }
      getNews(data)
        .then(res => {
          let newList = res.data.list
          if (num === 1) {
            this.newData = newList
            this.headerNew = newList[0]
          } else if (num === 2) {
            this.newsData = newList
            this.headerNews = newList[0]
          } else if (num === 3) {
            this.news = newList
            this.newsMsg = newList[0]
          }
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getNewsList', data).then(res => {
      //   if (res.data.code) {
      //     let newList = res.data.data.list
      //     if (num === 1) {
      //       this.newData = newList
      //       this.headerNew = newList[0]
      //     } else if (num === 2) {
      //       this.newsData = newList
      //       this.headerNews = newList[0]
      //     } else if (num === 3) {
      //       this.news = newList
      //       this.newsMsg = newList[0]
      //     }
      //   }
      // })
    },
    //详情
    handleMsg(o) {
      this.$router.push({
        path: this.ylStatus ? 'newsMsg_yl' : '/newsMsg',
        query: { id: o }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  background: #f7f9ff;
  display: flex;
  justify-content: center;
  padding: 70px 0 70px 30px;
  .news {
    h2 {
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
      text-align: start;
      text-align: initial;
    }

    h3 {
      text-align: start;
      text-align: initial;
      font-size: 18px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
      opacity: 0.7;
    }
    .imgbox {
      position: relative;
      cursor: pointer;
      div {
        position: absolute;
        bottom: 0;
        height: 55px;
        background: rgba(0, 0, 0, 1);
        opacity: 0.8;
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        text-align: start;
        text-align: initial;
        line-height: 55px;
        p {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .imgbox:hover {
      animation: scale_b 0.5s linear infinite alternate;
    }
    @-webkit-keyframes scale_b {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.15);
      }
    }
    .bottom div {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid rgba(130, 130, 130, 0.1);
      text-align: start;
      text-align: initial;
      cursor: pointer;
    }
    .msg_new p:hover {
      color: #0d7ef7;
    }
    .pad {
      font-size: 16px;
      font-weight: 400;
      color: #2a2a2a;
      cursor: pointer;
      text-align: center;
      opacity: 0.84;
    }
    .pad:hover {
      color: #0d7ef7;
    }
    .ell {
      width: 280px;
      margin-right: 20px;
    }
    .ell:hover {
      color: #0d7ef7;
    }
    .el-card {
      span,
      p {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
      }

      .image {
        min-width: 400px;
        height: 205px;
        display: block;
      }
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: '';
    }

    .clearfix:after {
      clear: both;
    }
    .el-card.is-always-shadow {
      box-shadow: none;
    }
  }
}
</style>
